import type { AdapterMeta } from "@repo/adapter-core";

export const LUTON_PROPERTIES_META: AdapterMeta = {
  slug: "luton-properties",
  name: "Luton Properties",
  baseUrl: "https://luton.com.au",
  description: "Canberra and ACT specialist agency with sold property coverage.",
  supportedStates: ["ACT"],
  urlPattern: /luton\.com\.au\/properties\/[a-z0-9-]+/i,
  sourceType: "agency",
};
